import { render, staticRenderFns } from "./LinkQues.vue?vue&type=template&id=36e8ede3&scoped=true"
import script from "./LinkQues.vue?vue&type=script&lang=js"
export * from "./LinkQues.vue?vue&type=script&lang=js"
import style0 from "./LinkQues.vue?vue&type=style&index=0&id=36e8ede3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../.yarn/__virtual__/vue-loader-virtual-45869d479f/4/.yarn/berry/cache/vue-loader-npm-15.11.1-829412283a-10c0.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e8ede3",
  null
  
)

export default component.exports